var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateReviewStar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0453 39.1198C25.4753 38.8199 24.7943 38.8196 24.2241 39.1189L13.6736 44.6573C12.2373 45.4112 10.5599 44.1914 10.8346 42.5927L12.8486 30.8704C12.9579 30.2342 12.7465 29.5851 12.2837 29.1352L3.74623 20.8379C2.58143 19.7058 3.22262 17.7295 4.83015 17.4969L16.6137 15.7918C17.2513 15.6995 17.8026 15.2994 18.0881 14.7219L23.3632 4.05006C24.0816 2.59664 26.1543 2.59664 26.8727 4.05006L32.1478 14.7219C32.4332 15.2994 32.9846 15.6995 33.6222 15.7918L45.4057 17.4969C47.0133 17.7295 47.6544 19.7058 46.4896 20.8379L37.9522 29.1352C37.4893 29.5851 37.278 30.2342 37.3873 30.8704L39.4005 42.5881C39.6753 44.1876 37.9962 45.4075 36.5599 44.6518L26.0453 39.1198Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5413 24.8953C27.8902 25.0206 29.0647 26.2577 29.0647 28.0116C29.0647 29.8438 27.7336 31.2531 25.0871 31.2531C23.5055 31.2531 21.9866 30.7051 21.1409 29.8438L21.689 28.9512C22.3937 29.6872 23.6621 30.2196 25.0871 30.2196C26.9037 30.2196 27.9059 29.374 27.9059 28.0116C27.9059 26.6962 26.982 25.8349 24.9462 25.8349H24.1632V25.005L27.2012 21.1997H21.5951V20.1975H28.6419V20.9961L25.5413 24.8953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateReviewStar3);
export default __webpack_public_path__ + "static/media/IconRateReviewStar-3.1f67012a0f15403459cf8a41f10131d3.svg";
export { ForwardRef as ReactComponent };